import {
  Circle,
  CircleX,
  Minus,
  MousePointer2,
  Plus,
  TriangleAlert,
  type LucideIcon
} from "lucide-react";
import { Badge, type BadgeProps } from "./badge";

export type StatusBadgeVariant =
  | "neutral"
  | "interactive"
  | "buy"
  | "sell"
  | "warning"
  | "destructive";

export interface StatusBadgeProps extends Omit<BadgeProps, "children" | "variant"> {
  variant?: StatusBadgeVariant;
  children: string | number;
  icon?: LucideIcon;
}

const statusIcons: Record<StatusBadgeVariant, LucideIcon> = {
  neutral: Circle,
  interactive: MousePointer2,
  buy: Plus,
  sell: Minus,
  warning: TriangleAlert,
  destructive: CircleX
};

export function StatusBadge({
  variant = "neutral",
  children,
  icon: Icon = statusIcons[variant],
  ...props
}: StatusBadgeProps) {
  return (
    <Badge variant={variant} data-status={variant} {...props}>
      <Icon className="h-3 w-3 shrink-0" aria-hidden="true" focusable="false" />
      <span>{children}</span>
    </Badge>
  );
}
